import { Component, OnInit }  from '@angular/core';
import { BaseComponent } from '../base.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SuccessModalHelperService } from '../_helpers/success-modal-helper/success-modal-helper.service';
import { UserService, RoleService, ClientService } from '../_services';
import { Observable } from 'rxjs';
import { AdministrationService } from '../_services/administration.service';

import { Router } from '@angular/router';
import { FeatureHelperService } from '../_helpers/feature-helper/feature-helper.service';
import { ErrorModalHelperService } from '../_helpers/error-modal-helper/error-modal-helper.service';
import { AuthenticationStateHelperService } from '../_helpers/authentication-state-helper/authentication-state-helper.service';

@Component({
    selector: 'settings',
    templateUrl: 'settings.component.html',
    styleUrls: ['settings.component.css'],
    standalone: false
})
export class SettingsComponent extends BaseComponent implements OnInit {

  frmClientUser: UntypedFormGroup;
  //frmClientUserEmail: FormGroup;
  loading: boolean = false;
  mobNumberPattern = "^((\\+91-?)|0)?[0-9]{10}$";
  edit: boolean = false;
  userId: number;
  errorMsg: string;
  ipAddress: string;
  clientData: any = {};
  showMfaTextField: boolean = false;
  showMfaTextUserField: boolean = false;
  showResendMfa: boolean = false;
  showContinueButton: boolean = false;
  showContinueUserButton: boolean = false;
  shouldValidateMfa: boolean = false;
  isPortalAdmin: boolean = false;
  changedDetails: any = [];
  changedEmail: any = [];

  public disableMfa: boolean = false;

  constructor(private formBuilder: UntypedFormBuilder,
    private successModalHelper: SuccessModalHelperService,
    private clientService: ClientService,
    private administration: AdministrationService,
    private roleSerive: RoleService,
    public router: Router,
    private featureHelperService: FeatureHelperService,
    private errorModalHelper: ErrorModalHelperService,
    private authenticationStateHelper: AuthenticationStateHelperService
    ) {
    super();

    this.frmClientUser = this.formBuilder.group({
      firstName: [null, Validators.required],
      lastName: [null, Validators.required],
      mobileNumber: [null],
      email: [null, Validators.required],
      mfaCode: [null],
      mfaEnabled: [null],
      stopAutomaticReports: [false]
    });
  }

  ngOnInit() {
    
    let featureList = new Array<string>();
    featureList.push("AccountSettingsEdit");

    let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

    if (!currentUserFeatures.filter(f => f.feature === "AccountSettingsEdit")[0].enabled) {
      console.error("User does not have the required permissions to view the account settings screen");
      this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname }});
      this.authenticationStateHelper.unauthorizedToken = true;
    }

    this.userId = this.authService.userSessionData.currentUser.id;
    this.checkIsAdmin();
    this.getAccountData();
  }

  private checkIsAdmin(): void {
    this.roleSerive.GetRolesByUser(this.authService.userSessionData.currentUser.id).subscribe((data: any) => {
      var clientRoles = data;
      clientRoles.forEach((x) => {
        if (x.role === 'CLIENT' || x.role === 'ADMIN' || x.roleCode === 'CLIENT' || x.roleCode === 'ADMIN') {
          this.isPortalAdmin = true;
        }
      });
    });
  }

  getAccountData() {
    this.userService.getById(this.userId).subscribe((data: any) => {
      this.clientData = data;
      this.frmClientUser.get("firstName").setValue(data.firstName);
      this.frmClientUser.get("lastName").setValue(data.lastName);
      this.frmClientUser.get("mobileNumber").setValue(data.mobileNumber);
      this.frmClientUser.get("email").setValue(data.email);
      this.frmClientUser.get("stopAutomaticReports").setValue(data.userOptions.stopAutomaticReports);

      this.shouldValidateMfa = data.userOptions.mfaEnabled;
      this.showContinueButton = data.userOptions.mfaEnabled;
      this.frmClientUser.get("mfaEnabled").setValue(data.userOptions.mfaEnabled);
      if (data.userOptions.mfaEnabled) {
        this.frmClientUser.get('mfaCode').setValidators([Validators.required]);
      }
      
      this.disableMfa = data.userOptions.mfaRequired;

    });
  }

  saveUser() {

    if (this.frmClientUser.invalid) {
      return;
    }
    this.getChangedDetails();
    if (this.changedDetails.length === 0) {
      this.successModalHelper.show("No changes detected");
      return;
    }
    var user = this.frmClientUser.value;
    user.id = this.authService.userSessionData.currentUser.id;
    // The API emails the owner what changed, with a link that disables the account.
    this.userService.updateUser(user).subscribe(data => {
      this.successModalHelper.show("Account details updated");
      this.clientData = user;
      this.showMfaTextField = false;
      this.showContinueButton = this.shouldValidateMfa;
      this.changedDetails = [];
    }, error => {
      this.errorModalHelper.show(error.message, error);
    });
  }
  
  generateMfa(type) {
    this.getChangedDetails();
    if (this.changedDetails.length === 0) {
      this.successModalHelper.show("No changes detected");
      return;
    }

    this.administration.createMfaCode(this.authService.userSessionData.currentUser.id).subscribe(result => {
      this.showMfaTextField = result > 0;
      this.showContinueButton = false;
      if (type === 'resend') {
        this.successModalHelper.show("New authentication code has been sent");
      }
    }, error => {
      this.errorModalHelper.show("Error generating authentication code", error);
    });
  }

  validateMfa() {
    if (this.frmClientUser.invalid) {
      return;
    }

    var data = {
      userId: this.authService.userSessionData.currentUser.id,
      mfaCode: this.frmClientUser.value.mfaCode
    };

    this.administration.validateMfaCode(data).subscribe(result => {
      this.saveUser();
    }, error => {
      this.errorModalHelper.show(error.message, error);
    })
  }

  submitUser() {
    if (this.frmClientUser.invalid) {
      return;
    }

    if (this.shouldValidateMfa) {
      this.validateMfa();
    }
    else {
      this.saveUser();
    }
  }

  updateMfa(event) {
    this.shouldValidateMfa = event.checked;
    this.showContinueButton = event.checked;
    this.frmClientUser.get("mfaEnabled").setValue(event.checked);
    if (event.checked) {
      this.frmClientUser.get('mfaCode').setValidators([Validators.required]);
    }

  }

  updateAutomaticReports(event) {
    this.frmClientUser.get("stopAutomaticReports").setValue(event.checked);
  }

  getChangedDetails() {
    this.changedDetails = [];
    if (this.frmClientUser.value.mfaEnabled !== this.clientData.userOptions.mfaEnabled) {
      this.changedDetails.push({ item: 'MfaEnabled', oldValue: this.clientData.userOptions.mfaEnabled, newValue: this.frmClientUser.value.mfaEnabled });
    }
    if (this.frmClientUser.value.stopAutomaticReports !== this.clientData.userOptions.stopAutomaticReports) {
      this.changedDetails.push({ item: 'stopAutomaticReports', oldValue: this.clientData.userOptions.stopAutomaticReports, newValue: this.frmClientUser.value.stopAutomaticReports });
    }
    if (this.frmClientUser.value.firstName !== this.clientData.firstName) {
      this.changedDetails.push({ item: 'FirstName', oldValue: this.clientData.firstName, newValue: this.frmClientUser.value.firstName });
    }
    if (this.frmClientUser.value.lastName !== this.clientData.lastName) {
      this.changedDetails.push({ item: 'LastName', oldValue: this.clientData.lastName, newValue: this.frmClientUser.value.lastName });
    }
    if (this.frmClientUser.value.mobileNumber !== this.clientData.mobileNumber) {
      this.changedDetails.push({ item: 'MobileNumber', oldValue: this.clientData.mobileNumber, newValue: this.frmClientUser.value.mobileNumber });
    }
    if (this.frmClientUser.value.email !== this.clientData.email) {
      this.changedDetails.push({ item: 'Email', oldValue: this.clientData.email, newValue: this.frmClientUser.value.email });
    }
  }
}
